import { render, staticRenderFns } from "./SubCardColumnaFinal.vue?vue&type=template&id=2c2eb7ee&"
import script from "./SubCardColumnaFinal.vue?vue&type=script&lang=js&"
export * from "./SubCardColumnaFinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports